import { Dispatch, SetStateAction } from "react";
import useAppContext from "./useAppContext";

interface IUseSliderRefreshReturn {
  sliderRefresh: boolean | undefined;
  setSliderRefresh: Dispatch<SetStateAction<boolean>> | undefined;
}

const useSliderRefresh = (): IUseSliderRefreshReturn => {
  const appContext = useAppContext();
  const sliderRefresh = appContext?.sliderRefresh;
  const setSliderRefresh = appContext?.setSliderRefresh;

  return { sliderRefresh, setSliderRefresh };
};

export default useSliderRefresh;
